<template>
  <nav ref="tabsNav" class="fixed bottom-0 left-0 right-0 bg-gradient-to-t from-purple-100/90 via-purple-50/90 to-white/90 backdrop-blur-sm p-4 z-20 md:mx-auto md:max-w-2xl">
    <div class="md:max-w-2xl md:mx-auto mb-4">
      <div class="flex justify-between items-end">
        <button
          v-for="tab in tabs"
          :key="tab.route"
          class="flex flex-col items-center rounded-2xl transition-colors flex-1"
          @click="isActiveTab(tab.title, tab.route)"
        >
          <span v-if="tab.title === 'appTabs.addMeal'" v-html="tab.svg" class="flex justify-center items-center"
            :class="{
              'w-14 h-14 shadow-md shadow-purple-200': tab.title === 'appTabs.addMeal',
              'text-moone-purple': tab.title === activeTab && tab.title !== 'appTabs.addMeal',
              'bg-gradient-to-br from-purple-600 via-purple-500 to-purple-700 text-white rounded-full': tab.title === 'appTabs.addMeal'
            }"
          />
          <span v-else v-html="tab.svg" class="h-6 sm:h-8 flex items-center justify-center"
            :class="{
              'text-moone-purple': tab.title === activeTab,
              'text-gray-500': tab.title !== activeTab
            }">
          </span>

          <span v-if="tab.title !== 'appTabs.addMeal'" class="text-xs mt-1"
                :class="{
                  'text-moone-purple': tab.title === activeTab,
                  'font-semibold': tab.title === activeTab
                }">
            {{ $t(`${tab.title}`) }}
          </span>
        </button>
      </div>
    </div>
    
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      paddingTop: 0,
      paddingBottom: 0,
      activeTab: 'appTabs.home',
    tabs: [
      {
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none">
            <path d="M3 11.9896V14.5C3 17.7998 3 19.4497 4.02513 20.4749C5.05025 21.5 6.70017 21.5 10 21.5H14C17.2998 21.5 18.9497 21.5 19.9749 20.4749C21 19.4497 21 17.7998 21 14.5V11.9896C21 10.3083 21 9.46773 20.6441 8.74005C20.2882 8.01237 19.6247 7.49628 18.2976 6.46411L16.2976 4.90855C14.2331 3.30285 13.2009 2.5 12 2.5C10.7991 2.5 9.76689 3.30285 7.70242 4.90855L5.70241 6.46411C4.37533 7.49628 3.71179 8.01237 3.3559 8.74005C3 9.46773 3 10.3083 3 11.9896Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M15 21.5V16.5C15 15.0858 15 14.3787 14.5607 13.9393C14.1213 13.5 13.4142 13.5 12 13.5C10.5858 13.5 9.87868 13.5 9.43934 13.9393C9 14.3787 9 15.0858 9 16.5V21.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>`,
        title: 'appTabs.home',
        route: 'daily-dashboard',
        highlight_route_prefixes: ['daily-dashboard']
      },
      {
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none">
              <path d="M3.5 13.678C3.5 9.49387 7.08079 5.35907 9.59413 2.97222C10.9591 1.67593 13.0409 1.67593 14.4059 2.97222C16.9192 5.35907 20.5 9.49387 20.5 13.678C20.5 17.7804 17.2812 22 12 22C6.71878 22 3.5 17.7804 3.5 13.678Z" stroke="currentColor" stroke-width="1.5"></path>
          </svg>`,
        route: 'period',
        title: 'appTabs.periods',
      },
      {
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none">
              <path d="M12 4V20M20 12H4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>`,
        route: 'habit-tracker',
        title: 'appTabs.habitTracker',
      },
      {
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none">
            <path d="M14.9805 7.01556C14.9805 7.01556 15.4805 7.51556 15.9805 8.51556C15.9805 8.51556 17.5687 6.01556 18.9805 5.51556" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.99491 2.02134C7.49644 1.91556 5.56618 2.20338 5.56618 2.20338C4.34733 2.29053 2.01152 2.97385 2.01154 6.96454C2.01156 10.9213 1.9857 15.7993 2.01154 17.7439C2.01154 18.932 2.74716 21.7033 5.29332 21.8518C8.38816 22.0324 13.9628 22.0708 16.5205 21.8518C17.2052 21.8132 19.4847 21.2757 19.7732 18.7956C20.0721 16.2263 20.0126 14.4407 20.0126 14.0157" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M21.9999 7.01556C21.9999 9.77698 19.7592 12.0156 16.9951 12.0156C14.231 12.0156 11.9903 9.77698 11.9903 7.01556C11.9903 4.25414 14.231 2.01556 16.9951 2.01556C19.7592 2.01556 21.9999 4.25414 21.9999 7.01556Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            <path d="M6.98053 13.0156H10.9805" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            <path d="M6.98053 17.0156H14.9805" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>`,
        title: 'appTabs.reports',
        route: 'report',
        highlight_route_prefixes: ['report']
      },
      {
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none">
            <path d="M15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12Z" stroke="currentColor" stroke-width="1.5"></path>
            <path d="M20.7906 9.15201C21.5969 10.5418 22 11.2366 22 12C22 12.7634 21.5969 13.4582 20.7906 14.848L18.8669 18.1638C18.0638 19.548 17.6623 20.2402 17.0019 20.6201C16.3416 21 15.5402 21 13.9373 21L10.0627 21C8.45982 21 7.6584 21 6.99807 20.6201C6.33774 20.2402 5.93619 19.548 5.13311 18.1638L3.20942 14.848C2.40314 13.4582 2 12.7634 2 12C2 11.2366 2.40314 10.5418 3.20942 9.152L5.13311 5.83621C5.93619 4.45196 6.33774 3.75984 6.99807 3.37992C7.6584 3 8.45982 3 10.0627 3L13.9373 3C15.5402 3 16.3416 3 17.0019 3.37992C17.6623 3.75984 18.0638 4.45197 18.8669 5.83622L20.7906 9.15201Z" stroke="currentColor" stroke-width="1.5"></path>
        </svg>`,
        route: 'settings',
        title: 'appTabs.settings',
      },
    ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    })
  },
  mounted() {
    this.setTabsHeight();
    // Update height on resize
    window.addEventListener('resize', this.setTabsHeight);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.setTabsHeight);
  },
  methods: {
    setTabsHeight() {
      this.$nextTick(() => {
        if (this.$refs.tabsNav) {
          const height = this.$refs.tabsNav.offsetHeight;
          document.documentElement.style.setProperty('--app-tabs-height', `${height}px`);
          
          // Verify it was set
          const setHeight = getComputedStyle(document.documentElement).getPropertyValue('--app-tabs-height');
        }
      });
    },
    isActiveTab (tab, route) {
      this.activeTab = tab
      this.$logEvent('page_view', {
        event_type: 'tab_click',
        page_name: route
      })
      if(this.$route.name != route){
        this.$router.push({
        name:  route
      })
      }
    }
  }
}
</script>
